export const clinicalDepartmentNames = ({ departments }) => {
  if (departments.length)
    return departments.reduce((acc, department) => {
      const { value, description } = department
      acc[value] = description
      return acc
    }, {})
  return {}
}
